// @flow

import styled from "styled-components";
import NumberFormat from "react-number-format";
import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";
import ButtonDefault from "../../_atom/Buttons/default";

export const ClearButton = styled(ButtonDefault)`
  background: ${buildColor("white", "0")};
  position: absolute;
  width: 40px;
  height: 100%;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
`;

export const CustomAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${buildColor("white", "100")};
  padding: 16px 40px;
  text-align: center;
`;

export const MessageWrapper = styled.div`
  padding: 8px;
  background-color: ${buildColor("white", "100")};
`;

export const CustomAmountInput = styled(NumberFormat).attrs({
  id: "customAmountInputId",
  "data-qa-label": "customAmount-amountInput",
  prefix: "$",
  isNumericString: true,
  displayType: "input",
  decimalSeparator: ".",
  thousandSeparator: true,
  decimalScale: 2,
  allowNegative: false
})`
  height: 32px;
  margin: 0 8px;
  outline: none;
  border: none;
  font-size: 24px;
  color: ${buildColor("grey", "900")};
  text-align: center;
`;

export const CustomAmountLabel = buildText({
  fontSize: 11,
  color: buildColor("grey", "800")
});

export const UpdateButtonContainer = styled.div`
  border-top: 1px solid ${buildColor("grey", "300")};
  background-color: ${buildColor("blue", "000")};
  padding: 8px;

  & > button {
    width: 100%;
  }
`;
